import {getShoppingSubscriptionResultInfo} from '@web/actions/result'
import makeSlice from '@web/slices/pointPayment/sliceMaker'

import {fetchSubscription} from '../../actions'

const slice = makeSlice({
    extraReducers(builder) {
        builder
            .addCase(fetchSubscription.fulfilled, (state, {payload: {paymentMethodsResult}}) => {
                if (paymentMethodsResult) {
                    state.naverPayPoint.usePointAll = paymentMethodsResult.usePointAll
                }
            })
            .addCase(getShoppingSubscriptionResultInfo.fulfilled, (state, {payload}) => {
                state.naverPayPoint.usePointAll = payload.paymentMethodsInfo.usePointAll
            })
    },
})

export default slice.reducer
export const actions = slice.actions
